import React from 'react'
import { Field } from 'redux-form'

import { translate, settings, utils, i18n } from 'parking-react-common'

import { reduce } from 'lodash'

import { ui, routing, forms } from '../redux'

import form from '../components/Form'
import Panel from '../components/Panel'
import { Row, Column } from '../components/Grid'
import Select from '../components/Select'
import Button from '../components/Button'

const PreferencesForm = ({ isSubmitting, isPristine, t }) => {
    const languages = reduce(settings.AVAILABLE_LANGUAGES, (acc, code) => {
        const language = utils.getLanguageWithCode(code)
        const label = i18n.t(language.name)
        const value = code
        return {
            ...acc,
            [value]: label
        }
    }, {})

    const expiryNotificationOptions = reduce(settings.EXPIRY_NOTIFICATION_DURATIONS, (acc, seconds) => {
        const duration = utils.formatTime(seconds)
        const label = utils.humanizeTime(duration)
        const value = duration
        return {
            ...acc,
            [value]: label
        }
    }, {})

    const timezones = reduce(utils.label('parking-lots.timezone'),
        (acc, value, key) => ({ ...acc, [value]: key }), {})

    return (
        <Column span={ 8 }>
            <Panel title={ t('Preferences') }>
                <Field
                    name="language"
                    placeholder={ t('Language') }
                    label={ t('Language') }
                    component={ Select }
                    options={ languages }
                />
                <Field
                    name="expiring_notification_delta"
                    placeholder={ t('Time before notifying about parking expiry') }
                    label={ t('Time before notifying about parking expiry') }
                    component={ Select }
                    options={ expiryNotificationOptions }
                />
                <Field
                    name="timezone"
                    placeholder={ t('Timezone') }
                    label={ t('Timezone') }
                    component={ Select }
                    options={ timezones }
                />
                <Row>
                    <Column span={ 6 }>
                        <Button
                            type="submit"
                            label={ t('Save') }
                            size={ ui.SIZE.large }
                            intent={ ui.INTENT.primary }
                            isBlock
                            disabled={ isSubmitting || isPristine }
                        />
                    </Column>
                    <Column span={ 6 }>
                        <Button
                            label={ t('Cancel') }
                            size={ ui.SIZE.large }
                            link={ routing.routeFor('dashboard') }
                            isBlock
                        />
                    </Column>
                </Row>
            </Panel>
        </Column>
    )
}

PreferencesForm.propTypes = forms.propTypes

export default translate()(form({ id: forms.preferences.id })(PreferencesForm))
